/* eslint eqeqeq: 0 */
import { SET_SHOW_LINKS } from "../../constants/teaserList";

export default function (state = false, action) {
  if (action.type == SET_SHOW_LINKS) {
    return action.showLinks;
  }
  return state;
}
